"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaHistoricoEscolarObs = exports.yupHistoricoEscolarObs = void 0;
const yup = __importStar(require("yup"));
const estado_1 = require("./estado");
const utils_1 = require("../utils");
exports.yupHistoricoEscolarObs = yup.object({
    idHistoricoEscolarGrade: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Historico Escolar Grade'),
    idAluno: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .label('Aluno'),
    grau: yup.string().default('').label('Nivel'),
    observacao: yup.string().default('').max(2000, 'Máximo de 2000 caracteres.').label('Observacao'),
    legenda: yup.string().default('').max(1000, 'Máximo de 1000 caracteres.').label('Legenda'),
    atividade: yup.string().default('').max(1000, 'Máximo de 1000 caracteres.').label('Atividade'),
    cursoAnterior: yup.string().default('').max(60, 'Máximo de 60 caracteres.').label('Curso Anterior'),
    anoConclusao: yup.string().default('').max(4).default('').label('Ano'),
    instituicaoOrigem: yup.string().default('').max(100, 'Máximo de 100 caracteres.').label('Instituicao Origem'),
    cidadeOrigem: yup.string().default('').max(40, 'Máximo de 50 caracteres.').label('Cidade'),
    estadoOrigem: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla))
        .default('')
        .label('Estado'),
    dataOrigem: (0, utils_1.sge2Date)().default(null).nullable().label('Data Inicial'),
    habilitacaoOrigem: yup.string().default('').max(150, 'Máximo de 150 caracteres.').label('Habilitacao Origem'),
    observacaoOrigem: yup.string().default('').max(1000, 'Máximo de 1000 caracteres.').label('Observacao Origem'),
    faseOrigem: yup.string().default('').max(8, 'Máximo de 8 caracteres.').label('Fase Origem'),
    idadeOrigem: yup.string().default('').max(4, 'Máximo de 4 caracteres.').label('Idade Origem'),
    diasOrigem: yup.string().default('').max(4, 'Máximo de 4 caracteres.').label('Dias Origem'),
    cargaHorariaOrigem: yup.string().default('').max(4, 'Máximo de 4 caracteres.').label('Carga Horaria Origem'),
    faltaOrigem: yup.string().default('').max(4, 'Máximo de 4 caracteres.').label('Falta Origem'),
    situacaoOrigem: yup.string().default('').max(8, 'Máximo de 8 caracteres.').label('Situacao Origem'),
    registroNumero: yup.string().default('').max(5, 'Máximo de 5 caracteres.').label('Registro Numero'),
    registroFolha: yup.string().default('').max(5, 'Máximo de 5 caracteres.').label('Registro Folha'),
    registroLivro: yup.string().default('').max(10, 'Máximo de 10 caracteres.').label('Registro Livro'),
    registroDataPublicacao: (0, utils_1.sge2Date)().default(null).nullable().label('Registro Data Publicacao'),
    registroFolhaPublicacao: yup
        .string()
        .default('')
        .max(10, 'Máximo de 10 caracteres.')
        .label('Registro Folha Publicacao'),
    registroLocal: yup.string().default('').max(30, 'Máximo de 30 caracteres.').label('Registro Local'),
    registroData: (0, utils_1.sge2Date)().default(null).nullable().label('Registro Data'),
    avaliacao: yup.string().default('').max(500, 'Máximo de 500 caracteres.').label('Avaliacao'),
});
exports.schemaHistoricoEscolarObs = exports.yupHistoricoEscolarObs.shape({});
